<template>
  <div>
    <ei-works-list :works-list="worksPage.list"></ei-works-list>
    <ei-pages :total="worksPage.total" :page-num="worksPage.pageNum" :page-size="worksPage.pageSize"
              @pageNumChange="pageNumChange"></ei-pages>
  </div>
</template>

<script>
export default {
  name: 'EiWorksPage',
  props: {
    worksPage: {
      type: Object,
      required: true
    }
  },
  methods: {
    pageNumChange (pageNumNew) {
      this.$emit('pageNumChange', pageNumNew)
    },
    toWorkDetail (rowGuid) {
      this.$router.push({
        path: '/WorksDetail',
        query: { guid: rowGuid },
      })
    },
  }
}
</script>

<style scoped lang="scss">
</style>
